import React from "react";
import { useState,useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./SubCategory2.css";
import { Navigation, EffectCoverflow } from "swiper/modules";
import { VscChevronLeft, VscChevronRight } from "react-icons/vsc";
import { Link } from "react-router-dom";

const SubCategory2 = ({data}) => {

  const [bgImage, setBgImage] = useState("");


  const subcategories = data.get_home_component_details.content.map(
    (item, index) => ({
      id: index + 1, // Assigning unique IDs dynamically
      subcategory_auto_id: item.subcategory_auto_id,
      name: item.sub_category_name,
      url: `/categorypage/${item.subcategory_auto_id}`,
      image: item.subcategory_image_app
        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${item.subcategory_image_app}`
        : "https://via.placeholder.com/400", // Default placeholder if image is missing
    })
  );

  const truncateNameMobile = (name) => {
    return name.length > 6 ? name.substring(0, 6) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };
  const swiperRef_sc_2=useRef(null)

  return (
    <div
      className="m-2 rounded-lg py-5 shadow relative overflow-hidden "
      style={{
        backgroundColor: data.web_background_color,
      }}
    >
      {/* Background Image with Blur Effect */}
      {bgImage && (
        <div
          className="absolute inset-0 bg-cover bg-center blur-md transition-opacity duration-500 ease-in-out "
          style={{
            backgroundImage: `url(${bgImage})`,
            opacity: bgImage ? 1 : 0,
            zIndex: 0,
          }}
        ></div>
      )}

      {/* Main Content */}
      <h2
        className={`text-${data.title_alignment} p-4 font-bold ${data.web_title_font} uppercase relative z-10`}
        style={{ color: data.web_title_color }}
      >
        {data.title}
      </h2>

      <div className="hidden lg:flex flex-wrap justify-center px-4 relative z-10">
        <Swiper
          ref={swiperRef_sc_2}
          slidesPerView={6}
          spaceBetween={10}
          loop={subcategories.length > 6}
          watchOverflow={false}
          navigation={{
            nextEl: `.swiper-button-next-${data._id}`,
            prevEl: `.swiper-button-prev-${data._id}`,
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {subcategories.map((category) => (
            <SwiperSlide key={`${category.id}-${category.subcategory_auto_id}`}
            style={{ minWidth: "250px" }} >
              <div
                className="flex justify-center relative group"
                onMouseEnter={() => setBgImage(category.image)}
                onMouseLeave={() => setBgImage("")}
              >
                <div className="text-center p-1 flex items-center relative z-20">
                  <Link
                    to="/productlist"
                    state={{
                      subcategoryName: category.name,
                      sub_cat_id: category.subcategory_auto_id,
                    }}
                    className="flex flex-col items-center no-underline"
                  >
                    <div
                      className="rounded-full overflow-hidden"
                      style={{ height: "200px", width: "200px" }}
                    >
                      <img
                        src={category.image}
                        alt={category.name}
                        className="object-cover transition-transform duration-300 ease-in-out transform group-hover:scale-110"
                        style={{ height: "200px", width: "200px" }}
                      />
                    </div>

                    <div
                      className={`text-black text-lg font-bold uppercase text-center p-2 drop-shadow-lg  ${data.web_title_font}`}
                    >
                      {truncateNameDesktop(category.name)}
                    </div>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Arrows */}
        {subcategories.length > 6 && (
          <>
            <div className={`swiper-button-next-${data._id} swiper-button-next-3 mx-20`}>
              <VscChevronRight />
            </div>
            <div className={`swiper-button-prev-${data._id} swiper-button-prev-3 mx-20`}>
              <VscChevronLeft />
            </div>
          </>
        )}
      </div>

      {/* Mobile View: Rounded Carousel with 4 Items */}
      <div className="lg:hidden justify-center relative">
        <div className="flex justify-center relative z-10">
          {" "}
          {/* Ensuring swiper is above the background */}
          <Swiper
            ref={swiperRef_sc_2}
            modules={[Navigation, EffectCoverflow]}
            effect="coverflow"
            grabCursor
            centeredSlides
            slidesPerView={1.2}
            loop={true}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            pagination={{ clickable: true }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 350,
              modifier: 1,
            }}
            
            onSlideChange={(swiper) =>
              setBgImage(subcategories[swiper.realIndex].image)
            } // Update bgImage on slide change
          >
            {subcategories.map((category, index) => (
              <SwiperSlide
                key={`${category.id}-${category.subcategory_auto_id}`}
              >
                <Link
                  to="/productlist"
                  state={{
                    subcategoryName: category.name,
                    sub_cat_id: category.subcategory_auto_id,
                  }}
                  className="no-underline"
                >
                  <div className="relative rounded-lg overflow-hidden ">
                    <div className="image-wrapper bg-transparent">
                      <img
                        src={category.image}
                        alt={category.name}
                        className="object-cover rounded-full"
                        style={{ height: "400px", width: "300px" }}
                      />
                    </div>
                    <div className="details text-center bg-transparent">
                      <h3 className="text-xl font-bold text-black drop-shadow-md">
                        {category.name}
                      </h3>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className={`swiper-button-next-${data._id} swiper-button-next-3 mx-20`}
          >
            <VscChevronRight />
          </div>
          <div
            className={`swiper-button-prev-${data._id} swiper-button-prev-3 mx-20`}
          >
            <VscChevronLeft />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategory2;
